import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';

import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const TournamentBracket = () => {
    const tournamentList = [
        {
            "matchId": 851,
            "matchStartDate": "0001-01-01T00:00:00",
            "tournamentId": 74,
            "leftTeamId": 744,
            "leftTeamName": "Bolton Wanderers - The Field",
            "leftTeamIsField": true,
            "rightTeamId": 743,
            "rightTeamName": "Blackpool FC - The Field",
            "rightTeamIsField": true,
            "leftTeamPosition": 2,
            "rightTeamPosition": 3,
            "leftTeamScore": 0,
            "rightTeamScore": 0,
            "winnerTeamId": 0,
            "matchLevel": 4,
            "leftTeamMatchId": 0,
            "rightTeamMatchId": 0,
            "isCompleted": false,
            "createdBy": 2
        },
        {
            "matchId": 852,
            "matchStartDate": "0001-01-01T00:00:00",
            "tournamentId": 74,
            "leftTeamId": 755,
            "leftTeamName": "Cambridge United - The Field",
            "leftTeamIsField": true,
            "rightTeamId": 741,
            "rightTeamName": "Birmingham City - The Field",
            "rightTeamIsField": true,
            "leftTeamPosition": 10,
            "rightTeamPosition": 11,
            "leftTeamScore": 0,
            "rightTeamScore": 0,
            "winnerTeamId": 0,
            "matchLevel": 4,
            "leftTeamMatchId": 0,
            "rightTeamMatchId": 0,
            "isCompleted": false,
            "createdBy": 2
        },
        {
            "matchId": 853,
            "matchStartDate": "0001-01-01T00:00:00",
            "tournamentId": 74,
            "leftTeamId": 742,
            "leftTeamName": "Blackburn Rovers - The Field",
            "leftTeamIsField": true,
            "rightTeamId": 754,
            "rightTeamName": "Burton Albion - The Field",
            "rightTeamIsField": true,
            "leftTeamPosition": 12,
            "rightTeamPosition": 13,
            "leftTeamScore": 0,
            "rightTeamScore": 0,
            "winnerTeamId": 0,
            "matchLevel": 4,
            "leftTeamMatchId": 0,
            "rightTeamMatchId": 0,
            "isCompleted": false,
            "createdBy": 2
        },
        {
            "matchId": 854,
            "matchStartDate": "0001-01-01T00:00:00",
            "tournamentId": 74,
            "leftTeamId": 730,
            "leftTeamName": "AFC Bournemouth",
            "leftTeamIsField": false,
            "rightTeamId": 0,
            "rightTeamName": null,
            "rightTeamIsField": false,
            "leftTeamPosition": 0,
            "rightTeamPosition": 1,
            "leftTeamScore": 0,
            "rightTeamScore": 0,
            "winnerTeamId": 0,
            "matchLevel": 3,
            "leftTeamMatchId": 0,
            "rightTeamMatchId": 851,
            "isCompleted": false,
            "createdBy": 2
        },
        {
            "matchId": 855,
            "matchStartDate": "0001-01-01T00:00:00",
            "tournamentId": 74,
            "leftTeamId": 740,
            "leftTeamName": "Barrow AFC - The Field",
            "leftTeamIsField": true,
            "rightTeamId": 733,
            "rightTeamName": "Accrington Stanley",
            "rightTeamIsField": false,
            "leftTeamPosition": 2,
            "rightTeamPosition": 3,
            "leftTeamScore": 0,
            "rightTeamScore": 0,
            "winnerTeamId": 0,
            "matchLevel": 3,
            "leftTeamMatchId": 0,
            "rightTeamMatchId": 0,
            "isCompleted": false,
            "createdBy": 2
        },
        {
            "matchId": 856,
            "matchStartDate": "0001-01-01T00:00:00",
            "tournamentId": 74,
            "leftTeamId": 732,
            "leftTeamName": "AFC Wimbledon",
            "leftTeamIsField": false,
            "rightTeamId": 0,
            "rightTeamName": null,
            "rightTeamIsField": false,
            "leftTeamPosition": 4,
            "rightTeamPosition": 5,
            "leftTeamScore": 0,
            "rightTeamScore": 0,
            "winnerTeamId": 0,
            "matchLevel": 3,
            "leftTeamMatchId": 0,
            "rightTeamMatchId": 852,
            "isCompleted": false,
            "createdBy": 2
        },
        {
            "matchId": 857,
            "matchStartDate": "0001-01-01T00:00:00",
            "tournamentId": 74,
            "leftTeamId": 0,
            "leftTeamName": null,
            "leftTeamIsField": false,
            "rightTeamId": 731,
            "rightTeamName": "AFC Fylde",
            "rightTeamIsField": false,
            "leftTeamPosition": 6,
            "rightTeamPosition": 7,
            "leftTeamScore": 0,
            "rightTeamScore": 0,
            "winnerTeamId": 0,
            "matchLevel": 3,
            "leftTeamMatchId": 853,
            "rightTeamMatchId": 0,
            "isCompleted": false,
            "createdBy": 2
        },
        {
            "matchId": 858,
            "matchStartDate": "0001-01-01T00:00:00",
            "tournamentId": 74,
            "leftTeamId": 0,
            "leftTeamName": null,
            "leftTeamIsField": false,
            "rightTeamId": 0,
            "rightTeamName": null,
            "rightTeamIsField": false,
            "leftTeamPosition": 0,
            "rightTeamPosition": 1,
            "leftTeamScore": 0,
            "rightTeamScore": 0,
            "winnerTeamId": 0,
            "matchLevel": 2,
            "leftTeamMatchId": 854,
            "rightTeamMatchId": 855,
            "isCompleted": false,
            "createdBy": 2
        },
        {
            "matchId": 859,
            "matchStartDate": "0001-01-01T00:00:00",
            "tournamentId": 74,
            "leftTeamId": 0,
            "leftTeamName": null,
            "leftTeamIsField": false,
            "rightTeamId": 0,
            "rightTeamName": null,
            "rightTeamIsField": false,
            "leftTeamPosition": 2,
            "rightTeamPosition": 3,
            "leftTeamScore": 0,
            "rightTeamScore": 0,
            "winnerTeamId": 0,
            "matchLevel": 2,
            "leftTeamMatchId": 856,
            "rightTeamMatchId": 857,
            "isCompleted": false,
            "createdBy": 2
        },
        {
            "matchId": 860,
            "matchStartDate": "0001-01-01T00:00:00",
            "tournamentId": 74,
            "leftTeamId": 0,
            "leftTeamName": null,
            "leftTeamIsField": false,
            "rightTeamId": 0,
            "rightTeamName": null,
            "rightTeamIsField": false,
            "leftTeamPosition": 0,
            "rightTeamPosition": 1,
            "leftTeamScore": 0,
            "rightTeamScore": 0,
            "winnerTeamId": 0,
            "matchLevel": 1,
            "leftTeamMatchId": 858,
            "rightTeamMatchId": 859,
            "isCompleted": false,
            "createdBy": 2
        }
      ];
    
      // Helper function to find connected matches and determine winners
      const findMatchDetails = (matchId) => {
        const match = tournamentList.find(m => m.matchId === matchId);
        const nextMatch = tournamentList.find(m => 
          m.leftTeamMatchId === matchId || m.rightTeamMatchId === matchId
        );
        
        let winningTeam = null;
        if (match) {
          if (match.winnerTeamId === match.leftTeamId) {
            winningTeam = {
              id: match.leftTeamId,
              name: match.leftTeamName,
              isLeft: true
            };
          } else if (match.winnerTeamId === match.rightTeamId) {
            winningTeam = {
              id: match.rightTeamId,
              name: match.rightTeamName,
              isLeft: false
            };
          }
        }
    
        return {
          match,
          nextMatch,
          winningTeam,
          progressesToLeft: nextMatch?.leftTeamMatchId === matchId,
          progressesToRight: nextMatch?.rightTeamMatchId === matchId
        };
      };
    
      // Transform tournament data with proper progression logic
      const transformTournamentData = () => {
        const rounds = [];
        
        // Sort matches by position within each level
        const sortByPosition = (matches) => {
          return matches.sort((a, b) => {
            if (a.leftTeamPosition === b.leftTeamPosition) {
              return a.rightTeamPosition - b.rightTeamPosition;
            }
            return a.leftTeamPosition - b.leftTeamPosition;
          });
        };
    
        // Level 4 (First Round)
        const level4Matches = sortByPosition(tournamentList.filter(match => match.matchLevel === 4));
        const round4 = {
          title: 'First Round',
          seeds: level4Matches.map(match => {
            const { nextMatch, winningTeam, progressesToLeft, progressesToRight } = findMatchDetails(match.matchId);
            return {
              id: match.matchId,
              teams: [
                {
                  id: match.leftTeamId,
                  name: match.leftTeamName || 'No team',
                  isWinner: winningTeam?.isLeft || false,
                  progresses: progressesToLeft || progressesToRight,
                  score: match.leftTeamScore
                },
                {
                  id: match.rightTeamId,
                  name: match.rightTeamName || 'No team',
                  isWinner: !winningTeam?.isLeft && winningTeam !== null,
                  progresses: progressesToLeft || progressesToRight,
                  score: match.rightTeamScore
                }
              ],
              nextMatchId: nextMatch?.matchId,
              completed: match.isCompleted
            };
          })
        };
        rounds.push(round4);
    
        // Level 3 (Quarter Finals)
        const level3Matches = sortByPosition(tournamentList.filter(match => match.matchLevel === 3));
        const round3 = {
          title: 'Quarter Finals',
          seeds: level3Matches.map(match => {
            const { nextMatch, winningTeam, progressesToLeft, progressesToRight } = findMatchDetails(match.matchId);
            return {
              id: match.matchId,
              teams: [
                {
                  id: match.leftTeamId,
                  name: match.leftTeamName || 'No team',
                  isWinner: winningTeam?.isLeft || false,
                  progresses: progressesToLeft || progressesToRight,
                  score: match.leftTeamScore,
                  fromMatch: match.leftTeamMatchId
                },
                {
                  id: match.rightTeamId,
                  name: match.rightTeamName || 'No team',
                  isWinner: !winningTeam?.isLeft && winningTeam !== null,
                  progresses: progressesToLeft || progressesToRight,
                  score: match.rightTeamScore,
                  fromMatch: match.rightTeamMatchId
                }
              ],
              nextMatchId: nextMatch?.matchId,
              completed: match.isCompleted
            };
          })
        };
        rounds.push(round3);
    
        // Level 2 (Semi Finals)
        const level2Matches = sortByPosition(tournamentList.filter(match => match.matchLevel === 2));
        const round2 = {
          title: 'Semi Finals',
          seeds: level2Matches.map(match => {
            const { nextMatch, winningTeam, progressesToLeft, progressesToRight } = findMatchDetails(match.matchId);
            return {
              id: match.matchId,
              teams: [
                {
                  id: match.leftTeamId,
                  name: match.leftTeamName || 'No team',
                  isWinner: winningTeam?.isLeft || false,
                  progresses: progressesToLeft || progressesToRight,
                  score: match.leftTeamScore,
                  fromMatch: match.leftTeamMatchId
                },
                {
                  id: match.rightTeamId,
                  name: match.rightTeamName || 'No team',
                  isWinner: !winningTeam?.isLeft && winningTeam !== null,
                  progresses: progressesToLeft || progressesToRight,
                  score: match.rightTeamScore,
                  fromMatch: match.rightTeamMatchId
                }
              ],
              nextMatchId: nextMatch?.matchId,
              completed: match.isCompleted
            };
          })
        };
        rounds.push(round2);
    
        // Level 1 (Finals)
        const level1Matches = sortByPosition(tournamentList.filter(match => match.matchLevel === 1));
        const round1 = {
          title: 'Finals',
          seeds: level1Matches.map(match => {
            const { winningTeam } = findMatchDetails(match.matchId);
            return {
              id: match.matchId,
              teams: [
                {
                  id: match.leftTeamId,
                  name: match.leftTeamName || 'No team',
                  isWinner: winningTeam?.isLeft || false,
                  score: match.leftTeamScore,
                  fromMatch: match.leftTeamMatchId
                },
                {
                  id: match.rightTeamId,
                  name: match.rightTeamName || 'No team',
                  isWinner: !winningTeam?.isLeft && winningTeam !== null,
                  score: match.rightTeamScore,
                  fromMatch: match.rightTeamMatchId
                }
              ],
              completed: match.isCompleted
            };
          })
        };
        rounds.push(round1);
    
        return rounds;
      };
    
      const rounds = transformTournamentData();
    
      const CustomSeed = ({seed, roundIndex}) => {
        return (
          <div className={`match-box ${seed.completed ? 'completed' : 'pending'}`}>
            {seed.teams.map((team, idx) => (
              <div 
                key={team.id} 
                className={`
                  team-row 
                  ${team.name === 'No team' ? 'no-team' : 'has-team'} 
                  ${team.isWinner ? 'winner' : ''} 
                  ${team.progresses ? 'progresses' : ''}
                  ${team.fromMatch ? 'from-previous' : ''}
                `}
              >
                <div className="team-info">
                  <span className="team-name">{team.name}</span>
                  {team.score !== undefined && <span className="team-score">{team.score}</span>}
                </div>
                {team.isWinner && <span className="winner-indicator">🏆</span>}
                {team.progresses && <span className="progress-indicator">→</span>}
              </div>
            ))}
            {!seed.completed && <div className="match-status">Pending</div>}
          </div>
        );
      };
    
      return (
        <div className="tournament-bracket">
          <h1>Tournament Bracket</h1>
          <div className="bracket-scroll">
            <div className="bracket-container">
              {rounds.map((round, idx) => (
                <div key={idx} className="round">
                  <div className="round-title">{round.title}</div>
                  {round.seeds.map((seed) => (
                    <div key={seed.id} className="seed">
                      <CustomSeed seed={seed} roundIndex={idx} />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      );
};

export default TournamentBracket;
